import { useEffect, useState } from "react";
import { getRadarFrames } from "../lib/api";

export const useRadarFrames = (active) => {
  const [radar, setRadar] = useState(null);
  const [idx, setIdx] = useState(0);
  const [playing, setPlaying] = useState(true);

  useEffect(() => {
    const loadFrames = () =>
      getRadarFrames()
        .then((d) => {
          setRadar(d);
          setIdx(Math.max(0, d.frames.findIndex((f) => f.kind === "nowcast") - 1));
        })
        .catch(() => setRadar({ host: "", frames: [] }));
    loadFrames();
    const t = setInterval(loadFrames, 5 * 60 * 1000);
    return () => clearInterval(t);
  }, []);

  const frames = radar?.frames || [];

  useEffect(() => {
    if (!playing || !active || frames.length === 0) return;
    const t = setInterval(() => setIdx((i) => (i + 1) % frames.length), 800);
    return () => clearInterval(t);
  }, [playing, active, frames.length]);

  return { host: radar?.host || "", frames, idx, setIdx, playing, setPlaying, current: frames[idx], next: frames[(idx + 1) % (frames.length || 1)] };
};
